export const blockLinkType = 'blockLink';
